import { h, render, Component } from 'preact';
import { translate } from 'react-i18next';

class Loading extends Component {
	render() {
		const { t } = this.props;
		return (
			<div className="loading-wrapper">
				<div className="loading" />
				<div className="loading-copy">{t('Logging Into Your Account')}</div>
			</div>
		);
	}
}

export default translate(['common'], { withRef: true })(Loading);


// WEBPACK FOOTER //
// ./components/LoginPanelLoading.js